import { IModalMethods, IModalProps } from "@/interfaces/Modal";
import {
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import { Button, Form, Modal as RBModal } from "react-bootstrap";

const Modal: ForwardRefRenderFunction<IModalMethods, IModalProps> = (
  {
    onSubmit,
    children,
    isLoading,
    beforeFooter,
    title,
    dangerDescription,
    onHide,
    continueTitle = "Continuer",
    requiredLabel = false,
  },
  ref,
) => {
  const [show, setShow] = useState<boolean>(false);

  const showOrHiddenModal = () =>
    setShow((old) => {
      if (old && onHide) onHide();
      return !old;
    });

  useImperativeHandle(ref, () => ({
    showOrHiddenModal,
  }));

  return (
    <RBModal
      size="xl"
      show={show}
      className="formalys-modal"
      aria-labelledby="contained-RBModal-title-vcenter"
      aria-describedby={
        requiredLabel || dangerDescription ? "formalys-modal-description" : undefined
      }
      onHide={showOrHiddenModal}
      centered
    >
      {onSubmit ? (
        <Form onSubmit={onSubmit}>
          <RBModal.Header closeButton>
            <RBModal.Title
              id="contained-RBModal-title-vcenter"
              className="d-flex flex-column"
            >
              {title}
              {requiredLabel && (
                <span id="formalys-modal-description" className="mt-2 h6">
                  <span className="text-danger">*</span> champ(s) obligatoire(s)
                </span>
              )}
              {dangerDescription && (
                <span className="mt-2 h6">
                  <span className="text-danger">{dangerDescription}</span>
                </span>
              )}
            </RBModal.Title>
          </RBModal.Header>
          <RBModal.Body>{children}</RBModal.Body>
          <RBModal.Footer>
            {beforeFooter}
            <Button type="submit" disabled={isLoading}>
              {continueTitle}
            </Button>
            <Button onClick={() => showOrHiddenModal()} variant="danger">
              Fermer
            </Button>
          </RBModal.Footer>
        </Form>
      ) : (
        <>
          <RBModal.Header closeButton>
            <RBModal.Title
              id="contained-RBModal-title-vcenter"
              className="d-flex flex-column"
            >
              {title}
              {dangerDescription && (
                <span id="formalys-modal-description" className="mt-2 text-danger">
                  {dangerDescription}
                </span>
              )}
            </RBModal.Title>
          </RBModal.Header>
          <RBModal.Body>{children}</RBModal.Body>
          <RBModal.Footer>
            {beforeFooter}
            <Button onClick={showOrHiddenModal} variant="danger">
              Fermer
            </Button>
          </RBModal.Footer>
        </>
      )}
    </RBModal>
  );
};

export default forwardRef(Modal);
